// Package Imports
import { z } from 'zod'

// Core Imports
import { adminListSearchSchema } from '@/core/lib/table-search-schema'
import { buildAchievementUnlockRulesSchema } from '@/core/lib/achievement-unlock-schema'
import { INDIVIDUAL_ACHIEVEMENT_METRICS } from '@/core/utils/achievement-unlock'

// Metric-based kazanım koşulları — same rule DSL the season builder uses, keyed
// to the player-side metric catalog.
const unlockRulesSchema = buildAchievementUnlockRulesSchema(
  INDIVIDUAL_ACHIEVEMENT_METRICS
)

const errors = {
  name: {
    required: 'Başarım ismi alanı girilmesi zorunludur',
    min: 'Başarım ismi alanı en az 2 karakter olmalıdır',
    max: 'Başarım ismi alanı en fazla 50 karakter olmalıdır',
  },
  description: {
    required: 'Açıklama alanı girilmesi zorunludur',
    max: 'Açıklama alanı en fazla 300 karakter olmalıdır',
  },
  file: {
    required: 'Logo alanı girilmesi zorunludur',
  },
}

export const individualAchievementSearchSchema = adminListSearchSchema

export const createIndividualAchievementSchema = z.object({
  name: z
    .string()
    .min(1, errors.name.required)
    .min(2, errors.name.min)
    .max(50, errors.name.max),
  description: z
    .string()
    .min(1, errors.description.required)
    .max(300, errors.description.max),
  file: z.custom<File>().refine((file) => file instanceof File, {
    message: errors.file.required,
  }),
  unlock_rules: unlockRulesSchema,
})

export const editIndividualAchievementSchema = z.object({
  name: z
    .string()
    .min(1, errors.name.required)
    .min(2, errors.name.min)
    .max(50, errors.name.max)
    .optional(),
  description: z
    .string()
    .min(1, errors.description.required)
    .max(300, errors.description.max)
    .optional(),
  file: z.custom<File>().optional(),
  unlock_rules: unlockRulesSchema.optional(),
})
